import React from 'react';
import PropTypes from 'prop-types';
// constants
import ROLES from '../../constants/Roles';
// elements
import { Card, CardHeader } from 'material-ui/Card';

import { List, ListItem } from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import CourseListItem from '../Course/CourseListItem.react';
import LoadingDialog from '../Common/LoadingDialog';
import DetailView from '../Common/DetailView';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import ProgrammeIcon from 'material-ui/svg-icons/action/assignment';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import ComplianceIcon from 'material-ui/svg-icons/action/assignment-turned-in';
// business logic
import ProgrammeStore from '../../stores/ProgrammeStore';
import ProgrammeCourseStore from '../../stores/ProgrammeCourseStore';
import ProgrammeActions from '../../actions/ProgrammeActionCreator';

import CourseStore from '../../stores/CourseStore';
import CourseActions from '../../actions/CourseActionCreator';
import SelectCourse from '../Course/SelectCourse';

import buildContextMenu from '../Common/BuildContextMenu';
import { statusColours } from '../../constants/ColourConstants';
import TextField from 'material-ui/TextField';
import { createComplianceFromProgramme } from '../../actions/ComplianceActionCreator';

const CourseFinder = (courseId) => (e) => (e !== undefined && e.courseId === courseId);

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const Programme = React.createClass({

    getInitialState: function () {
        return {
            details: {
                id: '',
                name: '',
                description: '',
                sysStatus: 0,
            },
            courses: [],
            dialog: {
                open: '',
                value: false,
            },
            dataSource: {
                courses: [],
            },
            actions: [],
            isManager: false,
            links: {
                back: '/dashboard/programmes',
                new:  '/dashboard/programme/new',
                edit: '',

            },
        }
    },

    getMenuItems: function() {
        return [
            {
                icon: <SchoolIcon />,
                label: 'Add Course',
                action: this.openAddCourseDialog,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                icon: <ComplianceIcon />,
                label: 'Create compliance',
                action: this.openCreateComplianceDialog,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'divider'
            },
            {
                link: '/dashboard/programme/' + this.props.routeParams.id + '/edit',
                icon: <EditIcon />,
                label: 'Edit',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.props.routeParams.id,
                title: 'Delete ',
                deleteAction: this.onDelete,
                message: (<span>Are you sure you want to delete this programme?</span>),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    componentWillMount: function() {
        this.setState({
            actions: buildContextMenu(this.getMenuItems(), this.context.auth),
            isAdmin: this.context.auth.hasRole(ROLES.ADMIN)
        });
    },

    componentDidMount: function() {
        ProgrammeStore.addChangeListener(this.onChange);
        ProgrammeActions.getById(this.props.routeParams.id);

        ProgrammeCourseStore.addChangeListener(this.onCoursesChange);
        ProgrammeActions.getCourses(this.props.routeParams.id);

        CourseStore.addChangeListener(this.onDataSourceChange);
        CourseActions.getAll();
    },

    componentWillUnmount: function() {
        ProgrammeStore.removeChangeListener(this.onChange);
        ProgrammeCourseStore.removeChangeListener(this.onCoursesChange);
        CourseStore.removeChangeListener(this.onDataSourceChange);
    },

    render: function () {

        const self = this;

        let dialogProps = {open: false}, loading = false;
        if (this.state.dialog.open !== '') {
            let dialogActions = [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                <FlatButton key="submit" label="Submit" onTouchTap={this.dialogSave} disabled={this.state.dialog.value === null} />,
            ];
            switch (this.state.dialog.open) {
                case 'addCourse':
                    dialogProps = {open: true, title: 'Add Course'};
                    loading = (this.state.dataSource.courses.length === 0);
                    if (!loading) {
                        dialogProps.actions = dialogActions;
                        dialogProps.children = (
                            <SelectCourse
                                clearOnSelect={false}
                                onSelect={(name, id) => this.onDialogSelect({name, id})}
                                onUpdate={() => this.onDialogSelect(null)}
                            />
                        );
                    }
                    break;
                case 'removeCourse':
                    if (this.state.dialog.value) {
                        const course = this.state.courses.find(CourseFinder(self.state.dialog.value));
                        if (course) {
                            dialogProps = {
                                open: true,
                                title: 'Remove Course',
                                children: <span>Do you really want to remove course '{course.name}' from the programme?</span>,
                                actions: [
                                    <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                                    <FlatButton key="submit" label="Remove" onTouchTap={this.dialogSave} />,
                                ]
                            }
                        }
                    }
                    break;
                case 'createCompliance':
                    dialogProps = {
                        open: true,
                        title: 'Create Compliance',
                        children: (
                            <TextField
                                name="name"
                                floatingLabelText="Compliance name"
                                value={this.state.dialog.value}
                                fullWidth={true}
                                onChange={({target}) => this.onDialogSelect(target.value) }
                            />
                        ),
                        actions: [
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                            <FlatButton key="submit" label="Create" onTouchTap={this.dialogSave} />,
                        ]
                    };
                    break;

                default:
                    break;
            }
        }

        let dialog = '';
        if (dialogProps.open) {
            if (loading) {
                dialog = <LoadingDialog {...dialogProps} buttonAction={this.closeDialog} />;
            } else {
                dialog = <Dialog {...dialogProps} onRequestClose={this.closeDialog} />
            }
        }

        return (
            <DetailView
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={this.state.details.name}
                            subtitle={this.state.details.description}
                            avatar={<ProgrammeIcon style={style.icon} color={this.state.courses.length > 0 ? statusColours.default : statusColours.disabled} />}
                        />
                        <List>
                           {this.state.courses.map((course) => {
                                course.id = course.courseId;
                                return (
                                    <div key={course.id}>
                                        <CourseListItem
                                            data={course}
                                            actions={self.getCourseActions(course)}
                                        />
                                    </div>
                                )
                            })}
                        </List>
                    </Card>
                </div>
                {dialog}
            </DetailView>
        );
    },

    onChange: function(){
        const details = ProgrammeStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    },

    onDelete: function(entityId) {
        if (entityId === this.props.routeParams.id) {
            ProgrammeActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

    onCoursesChange: function() {
        const courses = ProgrammeCourseStore.getCourses(this.props.routeParams.id);
        if (courses !== undefined) {
            this.setState({courses: courses});
        }
    },

    onDataSourceChange: function() {
        const self = this;
        const courses = CourseStore.getAll();
        if (courses !== undefined && courses.length > 0) {
            let ds_courses = courses.map(function(course) {
                const click = self.onDialogSelect.bind(self, course);
                const name = course.name + ' / ' + course.code;
                return {
                    text: course.name,
                    value: <ListItem key={course.id} value={course.id} primaryText={name} onClick={click} />
                };

            });
            this.setState({dataSource: {courses: ds_courses}});
        }
    },

    getCourseActions: function(course) {
        if (!this.context.auth.isAdmin()) { return []; }
        return [{
            label: 'Remove',
            icon: <ClearIcon/>,
            action: () => this.openDialog('removeCourse', course.courseId)
        }];
    },

    addCourse: function(course) {
        let valid = false;
        if (course !== undefined) {
            let index = this.state.courses.findIndex(function(e) {
                return e !== undefined && e.id === course.id;
            });
            if (0 > index) {
                valid = true;
                course.loading = true;
                let courses = this.state.courses;
                courses.push(course);
                this.setState({courses: courses});
            }
            ProgrammeActions.addCourse(this.props.routeParams.id, course.id);
        }
        return valid;
    },

    removeCourse: function(courseId) {
        let valid = false;
        if (courseId !== undefined) {
            const index = this.state.courses.findIndex(CourseFinder(courseId));
            if (0 <= index) {
                valid = true;
                let courses = this.state.courses;
                courses[index].loading = true;
                this.setState({courses: courses});
            }
            ProgrammeActions.removeCourse(this.props.routeParams.id, courseId);
        }
        return valid;
    },

    // dialog methods:

    openAddCourseDialog: function() {
        return this.openDialog('addCourse');
    },

    openDialog: function(dialogName, value) {
        const dialog = {
            open: dialogName,
            value: (value === undefined ? null : value)
        };
        this.setState({dialog});
    },

    openCreateComplianceDialog: function() {
        return this.openDialog('createCompliance', this.state.details.name);
    },

    onDialogSelect: function(value) {
        const dialog = {...this.state.dialog, value};
        this.setState({dialog});
    },

    dialogSave: function() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'addCourse':
                close = this.addCourse(this.state.dialog.value);
                break;
            case 'removeCourse':
                close = this.removeCourse(this.state.dialog.value);
                break;
            case 'createCompliance':
                createComplianceFromProgramme(this.state.dialog.value, this.state.details.id);
                alert('The compliance is being created in the background.');
                break;
            default:
                console.error('unhandled dialog ' + this.state.dialog.open, this.state.dialog.value);
                close = false;
        }

        if (close) this.closeDialog();
    },

    closeDialog: function() {
        let dialog = this.state.dialog;
        dialog.open = '';
        this.setState({dialog: dialog});
    },



});

Programme.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Programme;
